import React, { useEffect, useState } from "react";
import Layout from "../layouts/index";
import { Typography, Grid2 as Grid } from "@mui/material";
import ArticleImage from "../assets/images/ArticleImage.png";
import { useLocation } from "react-router-dom";
import DiscoverSection from "../components/pagesComponents/DiscoverSection";
import ReactHtmlParser, {
  processNodes,
  convertNodeToElement,
  htmlparser2,
} from "react-html-parser";
import { styled } from "@mui/material/styles";
import $ from "jquery";

const PREFIX = "ArticlePage";

const classes = {
  articlePageTitle: `${PREFIX}-articlePageTitle`,
  articleMainGrid: `${PREFIX}-articleMainGrid`,
  mainImageGrid: `${PREFIX}-mainImageGrid`,
  subTextStyle: `${PREFIX}-subTextStyle`,
  mainCenterGrid: `${PREFIX}-mainCenterGrid`,
  headingTextMainGrid: `${PREFIX}-headingTextMainGrid`,
  keyPointsMainGrid: `${PREFIX}-keyPointsMainGrid`,
  articleDescGrid: `${PREFIX}-articleDescGrid`,
  articleDescText: `${PREFIX}-articleDescText`,
  authorGrid: `${PREFIX}-authorGrid`,
  authorImageGrid: `${PREFIX}-authorImageGrid`,
  authorDescTextGrid: `${PREFIX}-authorDescTextGrid`,
  socialMainGrid: `${PREFIX}-socialMainGrid`,
  socialIconsGrid: `${PREFIX}-socialIconsGrid`,
  socialMediaiconStyle: `${PREFIX}-socialMediaiconStyle`,
  discoverMainGrid: `${PREFIX}-discoverMainGrid`,
  tileGrid: `${PREFIX}-tileGrid`,
  imageStyle: `${PREFIX}-imageStyle`,
  tileTitleStyle: `${PREFIX}-tileTitleStyle`,
  readTextGrid: `${PREFIX}-readTextGrid`,
  linkTextStyle: `${PREFIX}-linkTextStyle`,
  customerImage: `${PREFIX}-customerImage`,
};

const StyledGrid = styled(Grid)(({ theme }) => ({
  [`& .${classes.articlePageTitle}`]: {
    letterSpacing: "0.66px",
    color: "#223140",
    padding: "0em 0.5em 0 1em",
    fontFamily: "AvenirLTStd-Roman",
    fontSize: 35,
    [theme.breakpoints.down("sm")]: {
      fontSize: 25,
    },
  },
  [`& .${classes.articleMainGrid}`]: {
    display: "flex",
    flexDirection: "column",
  },
  [`& .${classes.mainImageGrid}`]: {
    display: "flex",
    justifyContent: "center",
  },
[`& .${classes.subTextStyle}`]: {
  padding: "1em",
  fontSize: 12,
  color: "red",
  [theme.breakpoints.down("xs")]: {
    fontSize: 10,
    padding: "0.5em", 
  },
},
[`& .${classes.subHeaderGrid}`]: {
  display: "flex",
  justifyContent: "center",
  padding: "2.7em 0 0 0",
  [theme.breakpoints.down("xs")]: {
    padding: "1.7em 0 0 0",
    fontSize: "0.8em", 
  },
},
  [`& .${classes.mainCenterGrid}`]: {
    display: "flex",
    justifyContent: "center",
    padding: "1em",
  },
  [`& .${classes.headingTextMainGrid}`]: {
    width: "65%",
    [theme.breakpoints.down("xs")]: {
      width: "100%",
    },
        [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  [`& .${classes.keyPointsMainGrid}`]: {
    backgroundColor: "#ffe6e6",
    borderRadius: "1em",
    padding: "0.8em",
    margin: "1em 0 0 0em",
    width: "60%",
    [theme.breakpoints.down("sm")]: {
      width: "95%",
      padding: 3
    },
        [theme.breakpoints.down("xs")]: {
      width: "95%",
      padding: 10
    },
  },
  [`& .${classes.articleDescGrid}`]: {
    display: "flex",
    justifyContent: "center",
    padding: "2em 0 2em 0",
    textAlign: "justify",
  },
  [`& .${classes.articleDescText}`]: {
    width: "70%",
    paddingBottom: "1rem",
    [theme.breakpoints.down("sm")]: {
      width: "95%",
      padding: 20
    },
  },
  [`& .${classes.authorGrid}`]: {
    padding: "1em 0 2em 0",
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
  },
  [`& .${classes.authorImageGrid}`]: {
    display: "flex",
    justifyContent: "center",
  },
  [`& .${classes.authorDescTextGrid}`]: {
    padding: "0.5em 0 0 1em",
    width: "90%",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      textAlign: "center",
    },
  },
  [`& .${classes.socialMainGrid}`]: {
    display: "flex",
    flexDirection: "column",
    padding: "1em 0 4em 0",
    alignItems: "center",
  },
  [`& .${classes.socialIconsGrid}`]: {
    padding: "1em 0 0 0",
    margin: "10px",
  },
  [`& .${classes.socialMediaiconStyle}`]: {
    fontSize: "2em",
    position: "relative",
  },
  [`& .${classes.discoverMainGrid}`]: {
    display: "flex",
    flexDirection: "column",
    padding: "1em 0 0em 0",
  },
  [`& .${classes.tileGrid}`]: {
    display: "flex",
    margin: "auto",
    maxWidth: "17rem",
    height: "20rem",
    backgroundColor: "#fefbfb",
    borderRadius: "1.5rem",
    flexDirection: "column",
    alignItems: "flex-start",
    padding: "1.4em",
    boxShadow: "5px 5px 19px 0px rgba(255, 230, 230)",
    cursor: "pointer",
    "&:hover": {
      marginTop: "-0.3rem",
      marginLeft: "-0.1rem",
    },
  },
  [`& .${classes.imageStyle}`]: {
    display: "flex",
    justifyContent: "center",
    objectFit: "contain",
    height: "50%",
    width: "100%",
  },
  [`& .${classes.tileTitleStyle}`]: {
    fontSize: 20,
    padding: "0.5em 0 0.5rem 0",
  },
  [`& .${classes.readTextGrid}`]: {
    display: "flex",
    justifyContent: "center",
  },
  [`& .${classes.linkTextStyle}`]: {
    fontSize: 16,
    color: "#fa1414",
    paddingTop: "1rem",
  },
  [`& .${classes.customerImage}`]: {
    position: "relative",
    width: "150px",
    height: "150px",
    objectFit: "contain",
    overflow: "hidden",
  },
}));

const ArticlePage = () => {
  const [value, setValue] = useState(0);
  const { state } = useLocation();

  const handleChange = (event, value) => {
    setValue(value);
  };

  useEffect(() => {
    loadCarousel();
  }, []);

  const loadCarousel = () => {
    $(".my-flipster").slick({
      autoplay: true,
      autoplaySpeed: 10000,
      infinite: true,
      vertical: true,
      verticalSwiping: true,
      slidesToShow: 1,
      slidesToScroll: 1,
    });
  };

  const { blog } = state;
  const blogData = state.blog;

  const baseUrl = "https://cms.redifly.com";
  const authorImage = blogData.authorImageTitle;
  const thumbnailUrl = blogData.thumbnailImageTitle;

  return (
    <div>
      <Layout>
        <StyledGrid container>
          <Grid size={{ xs: 12 }}>
            <Grid className={classes.articleMainGrid}>
              <Grid container className={classes.mainImageGrid}>
                <Grid size={{ xs: 1 }}></Grid>
                <Grid
                  size={{ xs: 10 }}
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <img
                    style={{ width: "100%", alignContent: "center" }}
                    src={thumbnailUrl}
                    alt="Article"
                  />
                </Grid>
                <Grid size={{ xs: 1 }}></Grid>
              </Grid>
              <Grid
                container
                className={classes.subHeaderGrid}
                justifyContent="center"
              >
                <Grid item>
                  <Typography
                    className={classes.subTextStyle}
                    style={{ display: "inline" }}
                  >
                    {blogData.author} -
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography
                    className={classes.subTextStyle}
                    style={{ display: "inline" }}
                  >
                    4 min read -
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography
                    className={classes.subTextStyle}
                    style={{ display: "inline" }}
                  >
                    {blogData.publishDate}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <div className={classes.mainCenterGrid}>
              <Grid size={{ xs: 12 }} className={classes.headingTextMainGrid}>
                <Typography variant="h1" className={classes.articlePageTitle}>
                  {blogData.title}
                </Typography>
              </Grid>
            </div>
            <div className={classes.mainCenterGrid}>
              <Grid size={{ xs: 12 }} className={classes.keyPointsMainGrid}>
                <Typography variant="h6" padding={2} style={{ color: "red" }}>
                  Introduction
                </Typography>
                <Typography variant="body2" padding={2}>{blogData.introduction}</Typography>
              </Grid>
            </div>
            <Grid
              size={{ xs: 12 }}
              container
              className={classes.articleDescGrid}
            >
              <Typography variant="body2" className={classes.articleDescText}>
                {ReactHtmlParser(blogData.content)}
              </Typography>
              <Typography variant="body2" className={classes.articleDescText}>
                {ReactHtmlParser(blogData.conclusion)}
              </Typography>
            </Grid>
            <Grid container className={classes.authorGrid}>
              <Grid
                size={{ xs: 12, sm: 4 }}
                className={classes.authorImageGrid}
              >
                <div className={classes.customerImage}>
                  <img
                    style={{ width: "90%" }}
                    src={authorImage}
                    alt="Author"
                  />
                </div>
              </Grid>
              <Grid size={{ xs: 12, sm: 6 }}>
                <Typography
                  variant="body2"
                  className={classes.authorDescTextGrid}
                >
                  {blogData.authorDetails}
                </Typography>
              </Grid>
              <Grid size={{ xs: 12, sm: 2 }}></Grid>
            </Grid>
            <Grid className={classes.mainCenterGrid}>
              <Grid className={classes.socialMainGrid}>
                <Typography variant="h6">Follow Us!</Typography>
                <Grid container className={classes.socialIconsGrid}>
                  <Grid size={{ xs: 4 }} className={classes.mainCenterGrid}>
                    <a
                      href="https://www.linkedin.com/company/redifly/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i
                        className={[
                          "fa-brands fa-linkedin-in",
                          classes.socialMediaiconStyle,
                        ].join(" ")}
                        aria-hidden="true"
                        style={{ color: "#2867B2" }}
                      />
                    </a>
                  </Grid>
                  <Grid size={{ xs: 4 }} className={classes.mainCenterGrid}>
                    <a
                      href="https://www.youtube.com/@redifly5063"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i
                        className={[
                          "fa-brands fa-youtube",
                          classes.socialMediaiconStyle,
                        ].join(" ")}
                        aria-hidden="true"
                        style={{ color: "#FF0000" }}
                      />
                    </a>
                  </Grid>
                  <Grid size={{ xs: 4 }} className={classes.mainCenterGrid}>
                    <a
                      href="https://www.instagram.com/redifly_/?hl=en"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        width="40"
                        height="40"
                        alt="insta-logo"
                        src="/images/instalogo.png"
                        className={classes.socialMediaiconStyle}
                      />
                    </a>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <DiscoverSection />
          </Grid>
        </StyledGrid>
      </Layout>
    </div>
  );
};

export default ArticlePage;
